export const DSN = "https://583eb3d4786b4b0791f6906ac68595cd@o60155.ingest.sentry.io/5790911";

/**
 * Derives the Sentry Security Policy Reporting endpoint from a Sentry DSN.
 * Used as the CSP `report-uri`/`report-to` target so browsers post CSP
 * violation reports to Sentry.
 * See https://docs.sentry.io/product/security-policy-reporting/
 */
export const getCspReportUri = (dsn: string = DSN): string => {
  const { username: publicKey, host, pathname } = new URL(dsn);
  const projectId = pathname.replace(/^\//, "");
  return `https://${host}/api/${projectId}/security/?sentry_key=${publicKey}`;
};
